module.exports = __WEBPACK_EXTERNAL_MODULE_39__;


//////////////////
// WEBPACK FOOTER
// external {"commonjs":"cornerstone-dicom-parser-utf8","commonjs2":"cornerstone-dicom-parser-utf8","amd":"cornerstone-dicom-parser-utf8","root":"dicomParser"}
// module id = 39
// module chunks = 0